import React from "react";
import { Link, useLocation } from "react-router-dom";

/* The kit's tab strip (.lp-tabs), the same one the mock interview dialog
   and the event list use. cls-nav was a row of pill buttons with an icon
   in each -- six glyphs that repeated their own labels, and a shape the
   rest of the project does not have.

   The icons went with them. A tab is a word; six coloured pills competing
   for attention is a toolbar, not a set of tabs. */
const TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "bookings", label: "Bookings" },
  { key: "labs", label: "Labs & classrooms" },
  { key: "trainers", label: "Trainers" },
  { key: "shifts", label: "Shifts & overrides" },
  { key: "reports", label: "Reports" },
];

const AppNav = () => {
  const location = useLocation();
  const activeKey = location.pathname.split("/").filter(Boolean)[1] || "dashboard";

  return (
    <nav className="lp-tabs cls-nav" aria-label="Classroom management">
      {TABS.map((tab) => (
        <Link
          key={tab.key}
          to={tab.key}
          className={`lp-tab${activeKey === tab.key ? " is-on" : ""}`}
          aria-current={activeKey === tab.key ? "page" : undefined}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
};

export default AppNav;
